import React, { createContext, useContext, useState } from "react";

const TaxonomyContext = createContext();

export const useTaxonomy = () => useContext(TaxonomyContext);

export const TaxonomyProvider = ({ children }) => {
  const [taxonomyPath, setTaxonomyPath] = useState("");

  return (
    <TaxonomyContext.Provider value={{ taxonomyPath, setTaxonomyPath }}>
      {children}
    </TaxonomyContext.Provider>
  );
};
